/** Preserve the authored heading in every language; character cuts can remove its meaning. */
export function conciseCrawlerHeading(heading: string, fallback?: string | null): string {
  return normalizeHeadingText(heading) || normalizeHeadingText(fallback ?? "");
}

export function fullHeadingLabel(fullHeading: string, renderedHeading: string): string | undefined {
  normalizeHeadingText(fullHeading);
  normalizeHeadingText(renderedHeading);
  return undefined;
}

function normalizeHeadingText(value: string): string {
  return value.trim().replace(/\s+/g, " ");
}
